var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errors-bag"},[_c('button',{staticClass:"errors-bag__close",attrs:{"type":"button"},on:{"click":_vm.close}},[_vm._v("×")]),_vm._l((_vm.errors),function(error,index){return _c('div',{key:index,staticClass:"errors-bag__item",domProps:{"innerHTML":_vm._s(error)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }